import { render } from "./ShowPackage.vue?vue&type=template&id=26be2882&scoped=true"
import script from "./ShowPackage.vue?vue&type=script&lang=js"
export * from "./ShowPackage.vue?vue&type=script&lang=js"

import "./ShowPackage.vue?vue&type=style&index=0&id=26be2882&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26be2882"]])

export default __exports__